import Root from "./Root";

// Sync route definition
export default {
  component: Root,
};
